import {Actions, StateChanges} from './stateChanges'
import {bindFirebaseRef, createFirebaseRefs, firebaseLogout, syncData} from './firebaseModule'
import savedExperiments from './savedExperimentUtils'

export default {
  [Actions.PROCESS_LOGIN]: ({ commit }) => {
    createFirebaseRefs()
    for (const dataType in syncData) {
      bindFirebaseRef(commit, dataType, syncData[dataType])
    }
    commit(StateChanges.LOGIN_COMPLETE)
  },
  [Actions.LOGOUT]: ({ commit }) => {
    commit(StateChanges.LOGGED_OUT)
    firebaseLogout()
  },
  [Actions.LOAD_EXPERIMENT] (store, experimentData) {
    savedExperiments.loadExperimentData(store, experimentData)
  }
}



// WEBPACK FOOTER //
// ./src/store/userActions.js